



















































































































import { EmployeApi } from "../api/EmployeApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import { Employe } from "../models/Employe";
import Contrat = Employe.Contrat;
import ContratModalEdit from "./ContratModalPartials/ContratModalEdit.vue";
import ContratModal from "./ContratModal.vue";
import AvenantModal from "./AvenantModal.vue";
import Avenant = Employe.Avenant;

export default {
    name: "EmployeContratList",
    components: { AvenantModal, ContratModal, ContratModalEdit },
    props: {
        employeId: Number,
    },
    data() {
        return {
            contrats: [],
            selectedContratId: null,
            newContrat: false,
            selectedAvenantContratId: null,
            selectedAvenantId: null,
            newAvenant: false,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.refreshContrats();
    },
    methods: {
        refreshContrats() {
            let self = this;
            if (self.employeId && self.employeId != 0) {
                self.EmployeApi.getContrats(self.employeId).then(function (
                    res
                ) {
                    self.contrats = res;
                });
            }
        },
        createContrat() {
            let self = this;
            self.newContrat = false;
            setTimeout(function () {
                self.newContrat = true;
            });
        },
        editContrat(contrat: Contrat) {
            let self = this;
            self.selectedContratId = null;
            setTimeout(function () {
                self.selectedContratId = contrat.id;
            });
        },
        deleteContrat(contrat: Contrat) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer ce contrat ?",
                contrat.avenants && contrat.avenants.length > 0
                    ? "Ses avenants partiront à la corbeille avec lui."
                    : undefined
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.EmployeApi.removeContrat(
                    self.employeId,
                    contrat.id,
                    raison
                )
                    .then(function () {
                        self.refreshContrats();
                    })
                    .catch(function () {
                        swal(
                            "Le contrat n'a pas pu être supprimé.",
                            "",
                            "error"
                        );
                    });
            });
        },
        createAvenant(contrat: Contrat) {
            let self = this;
            self.newAvenant = false;
            self.selectedAvenantContratId = contrat.id;
            setTimeout(function () {
                self.newAvenant = true;
            });
        },
        editAvenant(contrat: Contrat, avenant: Avenant) {
            let self = this;
            self.selectedAvenantId = null;
            self.selectedAvenantContratId = contrat.id;
            setTimeout(function () {
                self.selectedAvenantId = avenant.id;
            });
        },
        deleteAvenant(contrat: Contrat, avenant: Avenant) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cet avenant ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.EmployeApi.removeAvenant(
                    self.employeId,
                    contrat.id,
                    avenant.id,
                    raison
                )
                    .then(function () {
                        self.refreshContrats();
                    })
                    .catch(function () {
                        swal(
                            "L'avenant n'a pas pu être supprimé.",
                            "",
                            "error"
                        );
                    });
            });
        },
    },
};
